/**
 * Оптимизация изображений через Vercel Serverless Function
 * Проксирует изображения с кэшированием на CDN
 * @param {string} imageUrl - URL исходного изображения
 * @param {object} options - Параметры оптимизации
 * @param {number} options.width - Ширина изображения (по умолчанию 640)
 * @param {number} options.quality - Качество изображения 1-100 (по умолчанию 75)
 * @returns {string} - Оптимизированный URL
 */
export const optimizeImage = (imageUrl, options = {}) => {
  if (!imageUrl) return '';

  const { width = 640, quality = 75 } = options;

  // Проверяем, не является ли URL уже оптимизированным
  if (imageUrl.includes('/api/image')) {
    return imageUrl;
  }

  // Кодируем URL для безопасной передачи
  const encodedUrl = encodeURIComponent(imageUrl);

  // Формируем URL для нашей Serverless Function
  return `/api/image?url=${encodedUrl}&w=${width}&q=${quality}`;
};

/**
 * Оптимизация изображения для категорий
 * @param {string} imageUrl - URL изображения категории
 * @returns {string} - Оптимизированный URL с параметрами для категорий
 */
export const optimizeCategoryImage = (imageUrl) => {
  return optimizeImage(imageUrl, {
    width: 640,
    quality: 80,
  });
};

/**
 * Оптимизация изображения для модального окна продукта
 * @param {string} imageUrl - URL изображения продукта
 * @param {boolean} isMobile - Мобильная версия
 * @returns {string} - Оптимизированный URL с параметрами для продуктов
 */
export const optimizeProductImage = (imageUrl, isMobile = false) => {
  return optimizeImage(imageUrl, {
    width: isMobile ? 800 : 1200,
    quality: 85,
  });
};
